import { useEffect, useMemo, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../hooks';
import { IWorkerNew } from '../../../types';
import { Wrapper, ToggleWrapper } from './workers.styled';
import { WorkerSelect } from './components';
import { Toggle } from '../../index';
import { ApplicantCard } from '../index';

interface Props {
  canCollapsed?: boolean;
  withoutCallback?: boolean;
  id?: string;
  inCallCard?: boolean;
  card?: any;
}

export const Workers = observer(
  ({
    canCollapsed = true,
    withoutCallback = false,
    id,
    inCallCard,
    card,
  }: Props) => {
    const { createRequest, telephony } = useStore();
    const { workers, workerId, setSelectedId } = createRequest.applicant;

    const ref = useRef<HTMLDivElement>(null);
    const [open, setOpen] = useState<boolean>(false);

    useEffect(() => {
      if (!!workers[0]) {
        const callerInfo =
          inCallCard && card ? card.callerInfo : telephony.callerInfo;
        callerInfo.setCallerInfo(
          workers[0].str_name,
          workers[0].email || '',
          workers[0].phones[0]?.str_number || callerInfo.phone_number,
          '',
          ''
        );
      }

      if (!workerId) {
        const matchingPerson = workers.find((worker) =>
          worker.phones.some(
            (phone) => phone.str_number === createRequest.initialPhoneNumber
          )
        );

        matchingPerson && setSelectedId('workerId', matchingPerson.id);
      }
    }, []);

    const isCollapsed: boolean = useMemo(() => canCollapsed && !open, [open]);

    const handleOpen = (): void => {
      setOpen((open) => !open);
    };

    return (
      <Wrapper ref={ref} collapsed={isCollapsed}>
        {canCollapsed && (
          <ToggleWrapper>
            <Toggle
              open={open}
              onClick={handleOpen}
              disabled={workers.length <= 1}
            />
          </ToggleWrapper>
        )}

        <WorkerSelect collapsed={isCollapsed} />

        {workers.map((worker: IWorkerNew, index: number) => (
          <ApplicantCard
            key={index}
            applicant={worker}
            selected={workerId === worker.id}
            collapsed={isCollapsed}
            canCollapsed={canCollapsed}
            withoutCallback={withoutCallback}
            id={id}
            inCallCard={inCallCard}
            card={card}
          />
        ))}
      </Wrapper>
    );
  }
);
